import React from 'react';
import { ModalProps } from '@sls-react/components/Modal/ModalsGroup';

export interface ILoginModalContext extends ModalProps<'loginRegister'> {}

export const LoginModalContext = React.createContext<ILoginModalContext | null>(
  null,
);
